import { useQuery } from '@tanstack/react-query'
import { ApiError, api } from '@/api/client'
import type { TradingPlan } from '@/api/types'

/**
 * usePlan loads the TradingPlan for `date` (default: today KST).
 * 404s are NOT thrown — they resolve as `data = null` so callers can show
 * the empty-state UI without touching the error path.
 */
export function usePlan(date?: string) {
  return useQuery<TradingPlan | null>({
    queryKey: ['plan', date ?? 'today'],
    queryFn: async () => {
      try {
        return await api.plan(date)
      } catch (err) {
        if (err instanceof ApiError && err.status === 404) {
          return null
        }
        throw err
      }
    },
  })
}
